// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C8ot","title":"styles_title__3BR-Z"};